import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AgentNavBar from "./AgentNavBar";

const MyListings = () => {
    const [columns, setColumns] = useState(3);

    // Responsive columns
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 600) setColumns(1);
            else if (window.innerWidth < 992) setColumns(2);
            else setColumns(3);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Dummy data
    // const listings = [
    //     {
    //         id: 1,
    //         title: "Green Valley Resort",
    //         price: "₹ 25,000,000",
    //         area: "1500 sq ft",
    //         status: "SOLD",
    //         soldTo: "Investor X",
    //         commission: "₹ 50,000",
    //         image:
    //             "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
    //     },
    //     {
    //         id: 2,
    //         title: "Palm Residency",
    //         price: "₹ 12,500,000",
    //         area: "1200 sq ft",
    //         status: "AVAILABLE",
    //         image:
    //             "https://images.unsplash.com/photo-1600047509782-20d39509f26d",
    //     },
    //     {
    //         id: 3,
    //         title: "Lake View Villas",
    //         price: "₹ 18,000,000",
    //         area: "1400 sq ft",
    //         status: "PENDING",
    //         image:
    //             "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
    //     },
    // ];

    const statusColor = {
        Sold: "#d4edda",
        AVAILABLE: "#fff3cd",
        Pending: "#e2e3e5",
           Approved: "#cce5ff", // Added for "Approved"
    };

    const badgeText = {
        SOLD: "#155724",
        AVAILABLE: "#856404",
        PENDING: "#383d41",
         APPROVED: "#004085", // Added for "Approved"
        
    };



    const [listings, setListings] = useState([]);
    const [properties, setProperties] = useState([]);

    // useEffect(() => {
    //     const user = JSON.parse(localStorage.getItem("user"));
    //     const userId = Number(user?.id);

    //     // Get leads
    //     fetch("https://api.propertygalleria.in/master/api/get/leads")
    //         .then(res => res.json())
    //         .then(data => {
    //             const filtered = data.filter(
    //                 item => Number(item.handling_agent_id) === userId
    //             );
    //             setListings(filtered);
    //         });

    //     // Get properties
    //     fetch("https://api.propertygalleria.in/master/api/get/owner/properties")
    //         .then(res => res.json())
    //         .then(data => {
    //             if (data.success) {
    //                 setProperties(data.data);
    //             }
    //         });
    // }, []);

useEffect(() => {
    const fetchListings = async () => {
        try {
            const user = JSON.parse(localStorage.getItem("user"));

            if (!user || !user.id) {
                alert("User not logged in");
                return;
            }

            const userId = user.id;

            const res = await fetch(
                `https://api.propertygalleria.in/master/api/api/owner/properties/agent/${userId}`
            );

            const json = await res.json();

            if (!json.success) {
                alert("Failed to fetch properties");
                return;
            }

            // Map API response
            const mappedData = json.data.map((item) => {
                let displayStatus = item.status;

                if (item.status === "Approved") {
                    displayStatus = "AVAILABLE";
                } else if (item.status === "Sold") {
                    displayStatus = "SOLD";
                } else if (item.status === "Pending") {
                    displayStatus = "PENDING";
                }

                return {
                    id: item.id,
                    title: item.title,
                    location: item.location,
                    category: item.category_name || "Unknown",
                    zone: item.zone_desc || "Unknown",
                    zone_code: item.zone_code || "N/A",
                    nearby: item.nearby || "Unknown",
                    propertyType: item.property_type || "Unknown",
                    area: item.area,
                    price: item.price,
                    status: displayStatus,
                    images:
                        item.property_images?.length > 0
                            ? item.property_images
                            : [
                                  "https://via.placeholder.com/400x220.png?text=No+Image",
                              ],
                    documents: item.property_documents || [],
                };
            });

            setListings(mappedData);

        } catch (err) {
            console.error(err);
            alert("Error fetching properties");
        }
    };

    fetchListings();
}, []);

    console.log('this is properties', properties)
    const navigate = useNavigate();

    return (
        <>
            <AgentNavBar />
            <div style={{ marginTop: '5%', padding: 20, background: "#f5f6f8", minHeight: "100vh" }}>
                <h2 style={{ marginBottom: 10 }}>My Listings</h2>

                <p style={{ marginBottom: 20, color: "#666" }}>
                    Total: {listings.length} plots
                </p>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: `repeat(${columns}, 1fr)`,
                        gap: 20,
                    }}
                >


                    {/* {listings.map((item) => {
                    const property = properties.find(
                        p => p.id === item.property_id
                    );
                    const images = property?.property_images || [];
                    const zone_code = property?.zone_code 
                    const category = property?.category
                    return (
                        <div key={item.id} style={{
                            background: "#fff",
                            borderRadius: 12,
                            overflow: "hidden",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                        }}>

                          
                            <div style={{ position: "relative" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        overflowX: "auto",
                                        scrollSnapType: "x mandatory",
                                        scrollBehavior: "smooth",
                                    }}
                                >
                                    {images.length > 0 ? (
                                        images.map((img, index) => (
                                            <img
                                                key={index}
                                                src={img}
                                                alt=""
                                                style={{
                                                    width: "100%",
                                                    height: 220,
                                                    objectFit: "cover",
                                                    flexShrink: 0,
                                                    scrollSnapAlign: "start",
                                                }}
                                            />
                                        ))
                                    ) : (
                                        <img
                                            src="https://via.placeholder.com/400"
                                            alt=""
                                            style={{
                                                width: "100%",
                                                height: 220,
                                                objectFit: "cover",
                                            }}
                                        />
                                    )}
                                </div>

                              
                                {images.length > 0 && (
                                    <div style={{
                                        position: "absolute",
                                        bottom: 10,
                                        right: 10,
                                        background: "rgba(0,0,0,0.6)",
                                        color: "#fff",
                                        padding: "4px 8px",
                                        borderRadius: 8,
                                        fontSize: 12
                                    }}>
                                        {images.length} Photos
                                    </div>
                                )}

                                <div style={{
                                    position: "absolute",
                                    top: 12,
                                    right: 12,
                                    background: "#e2e3e5",
                                    padding: "6px 12px",
                                    borderRadius: 20,
                                    fontSize: 12,
                                    fontWeight: "bold",
                                }}>
                                    {item.status}
                                </div>
                            </div>

                            <div style={{ padding: 16 }}>
                                <h3 style={{ margin: 0 }}>
                                    {property?.title || item.property_title}
                                </h3>

                                <p style={{ color: "#777" }}>
                                    {item.location}
                                </p>
                                <p style={{ color: "#777" }}>
                                    {category}
                                </p>

                            </div>
                            
                        </div>
                    );
                })} */}
                {listings.map((property) => {

    const images = property.images || [];

    const status = property.status || "PENDING";

    const backgroundColor =
        statusColor[status] || "#e2e3e5";

    const textColor =
        badgeText[status] || "#383d41";

    return (
        <div
            key={property.id}
            style={{
                background: "#fff",
                borderRadius: 12,
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                cursor: "pointer"
            }}
        >

            {/* IMAGE */}
            <div style={{ position: "relative" }}>
                <div
                    style={{
                        display: "flex",
                        overflowX: "auto",
                        scrollSnapType: "x mandatory",
                    }}
                >
                    {images.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt=""
                            style={{
                                width: "100%",
                                height: 220,
                                objectFit: "cover",
                                flexShrink: 0,
                            }}
                        />
                    ))}
                </div>

                {/* Zone */}
                <div
                    style={{
                        position: "absolute",
                        top: 12,
                        left: 12,
                        background: "#007bff",
                        color: "#fff",
                        padding: "6px 12px",
                        borderRadius: 20,
                        fontSize: 12,
                        fontWeight: "bold",
                    }}
                >
                    {property.zone_code}
                </div>

                {/* Status */}
                <div
                    style={{
                        position: "absolute",
                        top: 12,
                        right: 12,
                        background: backgroundColor,
                        color: textColor,
                        padding: "6px 12px",
                        borderRadius: 20,
                        fontSize: 12,
                        fontWeight: "bold",
                    }}
                >
                    {status}
                </div>

                {/* Photos count */}
                <div
                    style={{
                        position: "absolute",
                        bottom: 10,
                        right: 10,
                        background: "rgba(0,0,0,0.6)",
                        color: "#fff",
                        padding: "4px 8px",
                        borderRadius: 8,
                        fontSize: 12
                    }}
                >
                    {images.length} Photos
                </div>
            </div>

            {/* DETAILS */}
            <div style={{ padding: 16 }}>
                <h3 style={{ margin: 0 }}>
                    {property.title}
                </h3>

                <p style={{ color: "#666", margin: "4px 0" }}>
                    📍 {property.location}
                </p>

                <p style={{ margin: "4px 0" }}>
                    Category: <b>{property.category}</b>
                </p>

                <p style={{ margin: "4px 0" }}>
                    Area: <b>{property.area} Acres</b>
                </p>

                <p
                    style={{
                        color: "#007bff",
                        fontWeight: "bold",
                        marginTop: 6
                    }}
                >
                    ₹ {property.price}
                </p>
            </div>
        </div>
    );
})}

               


                </div>
            </div>

        </>
    );
};

export default MyListings;


    //  {listings.map((item) => {
    //                     const property = properties.find(
    //                         p => p.id === item.property_id
    //                     );

    //                     if (!property) return null;

    //                     const images = property.property_images || [];

    //                     // Ensure a fallback status if status is missing
    //                     const status = property.status || "PENDING"; // Default to "PENDING" if status is missing

    //                     // Apply the background color and text color based on the status
    //               const backgroundColor = statusColor[status] || "#e2e3e5"; // Default to "#e2e3e5" if status not found
    //                     const textColor = badgeText[status] || "#383d41"; // Default to "#383d41" if status not found

    //                     console.log('this is status:', status); // Debugging line
    //                     console.log('backgroundColor:', backgroundColor); // Debugging line
    //                     console.log('textColor:', textColor); // Debugging line

    //                     return (
    //                         <div
    //                             key={item.id}
    //                             // onClick={() =>
    //                             //     navigate(`/product/${property.id}`, { state: property })
    //                             // }
    //                             style={{
    //                                 background: "#fff",
    //                                 borderRadius: 12,
    //                                 overflow: "hidden",
    //                                 boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    //                                 cursor: "pointer"
    //                             }}
    //                         >

    //                             {/* IMAGE CAROUSEL */}
    //                             <div style={{ position: "relative" }}>
    //                                 <div
    //                                     style={{
    //                                         display: "flex",
    //                                         overflowX: "auto",
    //                                         scrollSnapType: "x mandatory",
    //                                         scrollBehavior: "smooth",
    //                                     }}
    //                                 >
    //                                     {images.map((img, index) => (
    //                                         <img
    //                                             key={index}
    //                                             src={img}
    //                                             alt=""
    //                                             style={{
    //                                                 width: "100%",
    //                                                 height: 220,
    //                                                 objectFit: "cover",
    //                                                 flexShrink: 0,
    //                                                 scrollSnapAlign: "start",
    //                                             }}
    //                                         />
    //                                     ))}
    //                                 </div>

    //                                 {/* Zone badge */}
    //                                 <div style={{
    //                                     position: "absolute",
    //                                     top: 12,
    //                                     left: 12,
    //                                     background: "#007bff",
    //                                     color: "#fff",
    //                                     padding: "6px 12px",
    //                                     borderRadius: 20,
    //                                     fontSize: 12,
    //                                     fontWeight: "bold",
    //                                 }}>
    //                                     {property.zone_code}
    //                                 </div>

    //                                 {/* Lead status */}
    //                                 {/* <div style={{
    //                                     position: "absolute",
    //                                     top: 12,
    //                                     right: 12,
    //                                     // background: "#e2e3e5",
    //                                     background: statusColor[property.status] || "#e2e3e5", // Default to "#e2e3e5" if undefined
    //                                     color: badgeText[property.status] || "#383d41", // Default to "#383d41" if undefined

    //                                     padding: "6px 12px",
    //                                     borderRadius: 20,
    //                                     fontSize: 12,
    //                                     fontWeight: "bold",
    //                                 }}>
    //                                     {property.status}
    //                                 </div> */}
    //                                 <div
    //                                     style={{
    //                                         position: "absolute",
    //                                         top: 12,
    //                                         right: 12,
    //                                         background: backgroundColor,
    //                                         color: textColor,
    //                                         padding: "6px 12px",
    //                                         borderRadius: 20,
    //                                         fontSize: 12,
    //                                         fontWeight: "bold",
    //                                     }}
    //                                 >
    //                                     {status} {/* Use the status directly */}
    //                                 </div>

    //                                 {/* Image count */}
    //                                 <div style={{
    //                                     position: "absolute",
    //                                     bottom: 10,
    //                                     right: 10,
    //                                     background: "rgba(0,0,0,0.6)",
    //                                     color: "#fff",
    //                                     padding: "4px 8px",
    //                                     borderRadius: 8,
    //                                     fontSize: 12
    //                                 }}>
    //                                     {images.length} Photos
    //                                 </div>
    //                             </div>

    //                             {/* DETAILS */}
    //                             <div style={{ padding: 16 }}>
    //                                 <h3 style={{ margin: 0 }}>
    //                                     {property.title}
    //                                 </h3>

    //                                 <p style={{ color: "#666", margin: "4px 0" }}>
    //                                     📍 {property.location}
    //                                 </p>

    //                                 <p style={{ margin: "4px 0" }}>
    //                                     Category: <b>{property.category}</b>
    //                                 </p>

    //                                 <p style={{ margin: "4px 0" }}>
    //                                     Area: <b>{property.area} sq ft</b>
    //                                 </p>

    //                                 <p style={{
    //                                     color: "#007bff",
    //                                     fontWeight: "bold",
    //                                     marginTop: 6
    //                                 }}>
    //                                     ₹ {Number(property.price).toLocaleString()}
    //                                 </p>
    //                             </div>
    //                             {/* <button> Add Leads</button> */}
    //                         </div>
    //                     );
    //                 })}